import { computed } from 'vue';
import { InitialPublicOfferItem } from '@libs/api-reference';

import { AFTER_END_ORDER } from '../constants';

type UseAfterEndOrderType = {
  offer: InitialPublicOfferItem;
  isOpenOrder: boolean;
  isDoneOrder: boolean;
};

export default function useAfterEndOrder({
  offer,
  isOpenOrder,
  isDoneOrder,
}: UseAfterEndOrderType) {
  const flow = computed(() => {
    if (isDoneOrder) {
      return 'flow1';
    }

    if (isOpenOrder) {
      return 'flow2';
    }

    if (offer.hasPreOrder) {
      return 'flow3';
    }

    if (offer.isAutomaticSubmit) {
      return 'flow4';
    }

    return 'flow5';
  });

  return { time: null, stylesConfig: AFTER_END_ORDER[flow.value] };
}
